import styled from "styled-components";

export const TableNewDocumentContainer = styled.div`
  max-height: 31.25rem;
  overflow-y: auto;
`;